import React from "react";
import Reveal from "./Reveal";

const SETTLEMENTS = [
  { amount: "$1.175M", desc: "Head-on collision — severe wrist injuries" },
  { amount: "$1.0M", desc: "T-bone collision — neck & lower back injuries" },
  { amount: "$500K", desc: "Confidential auto accident settlement" },
  { amount: "$450K", desc: "Motor vehicle crash — neck & wrist injuries" },
  { amount: "$360K", desc: "T-bone collision — shoulder & neck injuries" },
  { amount: "$330K", desc: "Rear-ended by semi-truck — lower back" },
];

export default function Trust() {
  return (
    <section
      data-testid="trust-section"
      className="relative bg-[#091A33] py-24 md:py-32 overflow-hidden"
    >
      {/* Subtle gold accent line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-transparent to-[#B89968]/60" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <Reveal className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              Real Results, Real Clients
            </span>
            <div className="h-px w-10 bg-[#B89968]" />
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            Millions <span className="italic gold-text">Recovered</span> For The Injured.
          </h2>
          <p className="mt-6 text-[#94A3B8] text-lg leading-relaxed">
            A selection of settlements obtained by Newman Injury Law on behalf
            of clients hurt in auto accidents and other collisions.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SETTLEMENTS.map((s, i) => (
            <Reveal
              key={s.amount + i}
              delay={i * 70}
              className="group relative bg-[#15294C] border border-[#B89968]/15 p-8 md:p-10 transition-all duration-500 hover:border-[#B89968]/60 hover:-translate-y-1"
              data-testid={`settlement-card-${i}`}
            >
              <div className="absolute top-0 left-0 w-0 h-px bg-[#B89968] group-hover:w-full transition-all duration-700" />
              <div className="text-xs uppercase tracking-[0.28em] text-[#B89968] mb-4">
                Settlement
              </div>
              <div className="font-serif-display text-4xl md:text-5xl text-white mb-4 leading-none">
                {s.amount}
              </div>
              <div className="gold-rule mb-4" />
              <p className="text-[#94A3B8] text-sm md:text-base leading-relaxed">
                {s.desc}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 text-center text-xs text-[#64748B] max-w-2xl mx-auto">
          Past results do not guarantee future outcomes. Each case is unique and
          requires individual evaluation.
        </Reveal>
      </div>
    </section>
  );
}
